import { CaseTypes, RecordTypes } from '@config/state/globalSlices/apiSlice/constants';
import { useGetAccountFilesQuery, useGetAccountQuery, useGetCasesByTypeQuery, useGetDynamicsAccountManagerQuery, useGetSiteDetailsQuery } from '@config/state/globalSlices/apiSlice/requests';
import { useGetUserQuery } from '@config/state/globalSlices/apiSlice/requests';
import SidebarPageLayout from '@shared/components/SidebarPageLayout';
import { createNotification } from '@shared/utils/createNotification';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import AccountManagerTab from './components/AccountManagerTab';
import Tab from './components/Tab';
// import Guides from './guides';
import * as S from './styles';

const LocationPage = () => {
  const navigate = useNavigate();
  const { siteId } = useParams();
  const VITE_SF_FF_ENABLED = JSON.parse(import.meta.env.VITE_SF_FF_ENABLED);
  const [hasProductions, setHasProductions] = useState(false);

  // User Data
  const {
    data: userData,
    isLoading: userIsLoading,
    isError: userIsError,
  } = useGetUserQuery();

  const accountId = userData?.salesforceId as string;

  // Site Details
  const {
    data: siteDetails,
    isLoading: siteDetailsIsLoading,
    isError: siteDetailsisError,
  } = useGetSiteDetailsQuery(siteId || '', { skip: !siteId });

  // Account Details
  const {
    data: accountDetails,
    isLoading: accountDetailsIsLoading,
    isError: accountDetailsIsError,
  } = useGetAccountQuery(accountId, { skip: !accountId || !VITE_SF_FF_ENABLED });
  const accountName = accountDetails?.Name;

  // AWAITING APPROVAL
  const {
    data: copywriterCaseData,
    isLoading: copywriterCaseIsLoading,
    isError: copywriterCaseIsError,
  } = useGetCasesByTypeQuery(
    { accountId: accountId, recordType: RecordTypes.COPYWRITER, caseType: CaseTypes.DEMO },
    { skip: !accountId || !VITE_SF_FF_ENABLED }
  );
  const copywriterCaseNumber = copywriterCaseData?.[0]?.CaseNumber || '';
  if (copywriterCaseNumber && !hasProductions) {
    setHasProductions(true);
  }
  const {
    data: productionCaseData,
    isLoading: productionCaseIsLoading,
    isError: productionCaseIsError,
  } = useGetCasesByTypeQuery(
    { accountId: accountId, recordType: RecordTypes.PRODUCTION, caseType: CaseTypes.DEMO },
    { skip: !accountId || !VITE_SF_FF_ENABLED }
  );
  const productionCaseNumber = productionCaseData?.[0]?.CaseNumber || '';
  if (productionCaseNumber && !hasProductions) {
    setHasProductions(true);
  }

  // APPROVED PRODUCTIONS
  const {
    data: accountFiles,
    isLoading: accountFilesIsLoading,
    isError: accountFilesIsError,
  } = useGetAccountFilesQuery(accountName!, { skip: !accountName || !VITE_SF_FF_ENABLED });
  if (accountFiles && !hasProductions) {
    setHasProductions(true);
  }

  // No Productions or Cases // Is Loading
  const isLoading = (
    userIsLoading ||
    siteDetailsIsLoading ||
    accountDetailsIsLoading ||
    accountFilesIsLoading ||
    copywriterCaseIsLoading ||
    productionCaseIsLoading
  )

  const pageTitle = isLoading ? 'PHMG | Loading' : `PHMG | ${siteDetails?.siteName}`;

  useEffect(() => {
    if (userIsError && !userIsLoading) {
      createNotification({
        message: 'Failed to fetch user details. Please try again.',
        type: 'error',
      });
    }
    if (siteDetailsisError && !siteDetailsIsLoading) {
      createNotification({
        message: 'Failed to fetch site details. Please try again.',
        type: 'error',
      });
    }
    if (accountDetailsIsError && !accountDetailsIsLoading) {
      createNotification({
        message: 'Failed to fetch account details. Please try again.',
        type: 'error',
      });
    }
    if (productionCaseIsError && !productionCaseIsLoading) {
      createNotification({
        message: 'Failed to fetch productions. Please try again.',
        type: 'error',
      });
    }
    if (copywriterCaseIsError && !copywriterCaseIsLoading) {
      createNotification({
        message: 'Failed to fetch scripts. Please try again.',
        type: 'error',
      });
    }
    if (accountFilesIsError && !accountFilesIsLoading) {
      createNotification({
        message: 'Failed to fetch approved productions. Please try again.',
        type: 'error',
      });
    }
  }, [
    userIsError,
    userIsLoading,
    siteDetailsisError,
    siteDetailsIsLoading,
    accountDetailsIsError,
    accountDetailsIsLoading,
    accountFilesIsError,
    accountFilesIsLoading,
    productionCaseIsError,
    productionCaseIsLoading,
    copywriterCaseIsError,
    copywriterCaseIsLoading
  ]);

  const { data: accountManagerData, isLoading: accountManagerLoading } = useGetDynamicsAccountManagerQuery(
    {
      siteId: siteId as string,
      accountNumber: siteDetails?.accountNumber as string,
    },
    { skip: !siteId || !siteDetails?.accountNumber }
  );

  return (
    <SidebarPageLayout pageTitle={pageTitle} isLoading={isLoading}>
      {!isLoading && (
        <S.PageWrapper>
          <S.HolidayHeading>
            <S.HolidayTitle>{userData?.firstName ? `Hi ${userData?.firstName}` : 'Hi'}</S.HolidayTitle>
            <S.BannerSubtitle>Welcome back.</S.BannerSubtitle>
          </S.HolidayHeading>

          {/*<S.HolidayBanner>
            <S.BannerTitle>
              Get ready for the Holidays
            </S.BannerTitle>
            <S.BannerText>Update your holiday messages today</S.BannerText>
            <S.BannerActions href='https://phmg.com/global-holiday-campaign?utm_source=Portal&utm_medium=Dashboard&utm_campaign=HolidayCampaign' target='_blank'>
              <S.ActionText>Update now</S.ActionText>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.49951 8.00031C2.49951 7.8677 2.55219 7.74052 2.64596 7.64676C2.73973 7.55299 2.8669 7.50031 2.99951 7.50031L12.7926 7.50031L9.14576 3.85406C9.09931 3.8076 9.06246 3.75245 9.03731 3.69176C9.01217 3.63106 8.99923 3.56601 8.99923 3.50031C8.99923 3.43461 9.01217 3.36956 9.03731 3.30886C9.06246 3.24816 9.09931 3.19301 9.14576 3.14656C9.19222 3.1001 9.24737 3.06325 9.30806 3.03811C9.36876 3.01297 9.43381 3.00003 9.49951 3.00003C9.56521 3.00003 9.63026 3.01297 9.69096 3.03811C9.75166 3.06325 9.80681 3.1001 9.85326 3.14656L14.3533 7.64656C14.3997 7.693 14.4366 7.74814 14.4618 7.80884C14.487 7.86954 14.4999 7.9346 14.4999 8.00031C14.4999 8.06602 14.487 8.13108 14.4618 8.19178C14.4366 8.25248 14.3997 8.30762 14.3533 8.35406L9.85326 12.8541C9.75944 12.9479 9.63219 13.0006 9.49951 13.0006C9.36683 13.0006 9.23958 12.9479 9.14576 12.8541C9.05194 12.7602 8.99923 12.633 8.99923 12.5003C8.99923 12.3676 9.05194 12.2404 9.14576 12.1466L12.7926 8.50031L2.99951 8.50031C2.8669 8.50031 2.73973 8.44763 2.64596 8.35386C2.55219 8.26009 2.49951 8.13292 2.49951 8.00031Z" fill="currentColor" />
              </svg>

            </S.BannerActions>
          </S.HolidayBanner>*/}

          <S.TabHeader>
            How can we help you today?
          </S.TabHeader>

          <S.TabWrapper>
            <Tab
              primaryColor='#CCE3F2'
              secondaryColor='#007CFF'
              onClick={() => navigate(`/locations/${siteId}/${siteDetails?.accountNumber}/my-studio`)}
              logo="/Studio.svg"
              title='My Studio'
              label='All the elements of your audio production are ready at your fingertips.'
            />
            <Tab
              primaryColor='#FAF7F9'
              secondaryColor='#A48D9F'
              onClick={() => window.open('https://phmg.com/help-centre', '_blank')}
              logo="/question.svg"
              title='Help Centre'
              label='Troubleshoot common problems and find answers to common questions.'
            />
            {VITE_SF_FF_ENABLED && hasProductions && (
              <Tab
                primaryColor='#FFEECC'
                secondaryColor='#FFA800'
                onClick={() => navigate(`/locations/${siteId}/${siteDetails?.accountNumber}/brand-workshop`)}
                logo="/pencil.svg"
                title='Brand DNA'
                label='Explore your brand guidelines and how to bring them to life with audio.'
              />
            )}

            <AccountManagerTab loading={accountManagerLoading} phone={accountManagerData?.data.phone || ''} email={accountManagerData?.data.email || ''} name={accountManagerData?.data.fullName || ''}
            />
          </S.TabWrapper>

          {/* <Guides /> */}

        </S.PageWrapper>
      )}
    </SidebarPageLayout>
  );
};

export default LocationPage;
